import React from "react";

import styles from "./styles/CourseBanner.module.scss";

import { CardTitle } from "../CustomComponents";

import { IoIosArrowBack } from "react-icons/io";

export default function CourseBanner({
  hasBackButton = false,
  handleBackButtonClck = () => { },
  data,
  title,
  image_url
}) {
  return (
    <div className={styles.CourseBanner} key={data?.slug} role="button">
      {hasBackButton ? (
        <span className={styles.backButton} onClick={handleBackButtonClck}>
          <IoIosArrowBack />
        </span>
      ) : (
        ""
      )}
      <img
        src={image_url}
        alt="Card Banner"
        className={styles.bannerImage}
      />

      <div className={styles.shadowContainer}></div>

      <div className={styles.content}>
        <div className={styles.titleContainer}>
          <CardTitle text={title} classes="lc-1 fs-2 text-white" />
        </div>
      </div>
    </div>
  );
}
